
<div class="d-none d-xl-block">
  <div class="filters">
    <app-atlas-mobile-filter
      (selectedAreaChange)="searchArea($event)"
    ></app-atlas-mobile-filter>
  </div>
</div><div class="container-fluid">
  @if (showMap) {
    <div>
      <app-atlas-mobile-map></app-atlas-mobile-map>
    </div>
  }
</div>
<div id="mobile-filter">
  <div class="filter-container d-flex d-xl-none">
    <button class="btn btn-default" (click)="showFilter(); $event.stopPropagation()"
    aria-label="filters">
      <fa-icon [icon]="icons.falFilter" class="mr-1"></fa-icon>
      {{ "ui.charts.filters" | translate }}
    </button>
  </div>
  @if (isShowFilter) {
<div class="filters side-filter">
    <div class="container">
      <button class="close pt-2 pl-2" (click)="showFilter(); $event.stopPropagation()"
      aria-label="Close filter bar">
        <fa-icon [icon]="icons.falTimes"></fa-icon>
      </button>
    </div>
    <app-atlas-mobile-filter
      (selectedAreaChange)="searchArea($event)">
    </app-atlas-mobile-filter>
  </div>
}
</div>
<app-atlas-mobile-legend></app-atlas-mobile-legend>
<app-atlas-mobile-description [data]="dataDescription"></app-atlas-mobile-description>
